import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords,
  canonical,
  ogImage,
  ogType = 'website',
  structuredData,
  noindex = false,
  children
}) => {
  const siteUrl = 'https://octopus-sync.com';
  const defaultImage = `${siteUrl}/og-image.jpg`;

  const fullTitle = title
    ? `${title} | OctopusSync`
    : 'OctopusSync';
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const fullOgImage = ogImage ? `${siteUrl}${ogImage}` : defaultImage;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name='description' content={description} />
      {keywords && <meta name='keywords' content={keywords} />}
      <link rel='canonical' href={fullCanonical} />

      {noindex && <meta name='robots' content='noindex, nofollow' />}

      <meta property='og:title' content={fullTitle} />
      <meta property='og:description' content={description} />
      <meta property='og:type' content={ogType} />
      <meta property='og:url' content={fullCanonical} />
      <meta property='og:image' content={fullOgImage} />
      <meta property='og:image:width' content='1200' />
      <meta property='og:image:height' content='630' />
      <meta property='og:site_name' content='OctopusSync' />
      <meta property='og:locale' content='en_GB' />

      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={fullTitle} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content={fullOgImage} />

      {structuredData && (
        <script type='application/ld+json'>
          {JSON.stringify(structuredData)}
        </script>
      )}

      {children}
    </Helmet>
  );
};

export default SEO;
